import {
  CompanyName,
  CompanyPhoneNumber,
  FULL_BUSINESS_URL,
  INSTAGRAM_URL,
} from '../Constants';

/* ===========================
   INDEX (Landing) page
   =========================== */
export const indexPageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: CompanyName,
  url: FULL_BUSINESS_URL,
  description: `${CompanyName} — LA-based touring dominatrix specializing in hypnosis, sensual sadism, indoctrination, and mind play. Eyes ever watching.`,
  potentialAction: {
    '@type': 'SearchAction',
    target: `${FULL_BUSINESS_URL}/?s={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
  sameAs: [INSTAGRAM_URL],
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: CompanyPhoneNumber,
    contactType: 'Bookings',
    areaServed: 'US',
    availableLanguage: ['English'],
  },
};

export const indexPageAdditionalMeta = [
  {
    property: 'og:title',
    content: `${CompanyName} | Neon-Gothic Hypnosis & Sessions`,
  },
  {
    property: 'og:description',
    content:
      'Enter the realm of Lady Cinder — a neon-gothic deity of dominance. Hypnosis, sensual sadism, indoctrination, and mind play. Online & in person.',
  },
  { property: 'og:image', content: `${FULL_BUSINESS_URL}/social/og-image.jpg` },
  { property: 'og:url', content: FULL_BUSINESS_URL },
  { name: 'twitter:card', content: 'summary_large_image' },
  {
    name: 'twitter:title',
    content: `${CompanyName} | Neon-Gothic Hypnosis & Sessions`,
  },
  {
    name: 'twitter:description',
    content:
      'Eyes ever watching. Book Lady Cinder for hypnosis, sensual sadism, indoctrination, and mind play.',
  },
  {
    name: 'twitter:image',
    content: `${FULL_BUSINESS_URL}/social/og-image.jpg`,
  },
];

/* ===========================
   HOME page
   =========================== */
export const homePageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: CompanyName,
  url: FULL_BUSINESS_URL,
  description: `${CompanyName} — LA-based touring dominatrix. Neon-gothic aesthetic with celestial & sideshow elements. Hypnosis, sensual sadism, mind play.`,
  potentialAction: {
    '@type': 'SearchAction',
    target: `${FULL_BUSINESS_URL}/?s={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
  sameAs: [INSTAGRAM_URL],
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: CompanyPhoneNumber,
    contactType: 'Bookings',
    areaServed: 'US',
    availableLanguage: ['English'],
  },
};

export const homePageAdditionalMeta = [
  { property: 'og:title', content: `Welcome to ${CompanyName}` },
  {
    property: 'og:description',
    content:
      'Step into My neon-gothic dominion. Hypnosis, sensual sadism, indoctrination, and mind play — online & in person.',
  },
  { property: 'og:image', content: `${FULL_BUSINESS_URL}/social/og-image.jpg` },
  { property: 'og:url', content: FULL_BUSINESS_URL },
  { name: 'twitter:card', content: 'summary_large_image' },
  { name: 'twitter:title', content: `Welcome to ${CompanyName}` },
  {
    name: 'twitter:description',
    content: 'Eyes ever watching. Explore bookings, gallery, and tour dates.',
  },
  {
    name: 'twitter:image',
    content: `${FULL_BUSINESS_URL}/social/og-image.jpg`,
  },
];

/* ===========================
   ABOUT page
   =========================== */
export const aboutPageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'AboutPage',
  name: `${CompanyName} About`,
  url: `${FULL_BUSINESS_URL}/about`,
  description: `Learn about ${CompanyName} — the neon-gothic deity of dominance. A celestial circus of hypnosis, sensual sadism, and divine control.`,
  mainEntity: {
    '@type': 'Person',
    name: CompanyName,
    jobTitle: 'Professional Dominatrix',
    description: `LA-based touring dominatrix and performer. Known for hypnosis, sensual sadism, indoctrination, and mind play — all wrapped in neon-gothic fire.`,
    image: `${FULL_BUSINESS_URL}/about/cover.jpg`,
    sameAs: [INSTAGRAM_URL],
    worksFor: {
      '@type': 'Organization',
      name: CompanyName,
      url: FULL_BUSINESS_URL,
    },
  },
  isPartOf: {
    '@type': 'WebSite',
    name: CompanyName,
    url: FULL_BUSINESS_URL,
  },
};

export const aboutPageAdditionalMeta = [
  { property: 'og:title', content: `About ${CompanyName}` },
  {
    property: 'og:description',
    content:
      'I am a deity. Not just a goddess – an actual goddess. Learn about Lady Cinder: the hypnotic, neon-gothic force behind the flame.',
  },
  { property: 'og:image', content: `${FULL_BUSINESS_URL}/about/cover.jpg` },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/about` },
  { name: 'twitter:card', content: 'summary_large_image' },
  { name: 'twitter:title', content: `About ${CompanyName}` },
  {
    name: 'twitter:description',
    content:
      'Circus fire-eater. Hypnotic goddess. Celestial sadist. Discover the world of Lady Cinder — eyes ever watching.',
  },
  { name: 'twitter:image', content: `${FULL_BUSINESS_URL}/about/cover.jpg` },
];


/* ===========================
   GALLERY page
   =========================== */
export const galleryPageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'CollectionPage',
  name: `${CompanyName} Gallery`,
  url: `${FULL_BUSINESS_URL}/gallery`,
  description: `A visual journey into ${CompanyName}'s neon-gothic world — fire, hypnosis, and celestial elegance.`,
  isPartOf: {
    '@type': 'WebSite',
    name: CompanyName,
    url: FULL_BUSINESS_URL,
  },
};

export const galleryPageAdditionalMeta = [
  { property: 'og:title', content: `${CompanyName} Gallery` },
  {
    property: 'og:description',
    content:
      'Witness dominance, seduction, and neon fire. My curated gallery of hypnotic visuals.',
  },
  { property: 'og:image', content: `${FULL_BUSINESS_URL}/gallery/cover.jpg` },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/gallery` },
  { name: 'twitter:card', content: 'summary_large_image' },
  { name: 'twitter:title', content: `${CompanyName} Gallery` },
  {
    name: 'twitter:description',
    content: 'Celestial, gothic, and electric — explore My image collection.',
  },
  { name: 'twitter:image', content: `${FULL_BUSINESS_URL}/gallery/cover.jpg` },
];

/* ===========================
   REVIEWS page
   =========================== */
export const reviewsPageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: `${CompanyName} Reviews`,
  url: `${FULL_BUSINESS_URL}/reviews`,
  description: `Testimonials from submissives who surrendered to ${CompanyName} — hypnosis, sensual sadism, and mind play.`,
  sameAs: [INSTAGRAM_URL],
  potentialAction: {
    '@type': 'SearchAction',
    target: `${FULL_BUSINESS_URL}/reviews?s={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
};

export const reviewsPageAdditionalMeta = [
  { property: 'og:title', content: `Customer Reviews | ${CompanyName}` },
  {
    property: 'og:description',
    content: `Read experiences from those who entered My world — indoctrination, hypnosis, and divine control.`,
  },
  { property: 'og:image', content: `${FULL_BUSINESS_URL}/social/og-image.jpg` },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/reviews` },
  { name: 'twitter:card', content: 'summary_large_image' },
  { name: 'twitter:title', content: `Customer Reviews | ${CompanyName}` },
  {
    name: 'twitter:description',
    content: `What they say after surrender: honest reviews of ${CompanyName}.`,
  },
  {
    name: 'twitter:image',
    content: `${FULL_BUSINESS_URL}/social/og-image.jpg`,
  },
];

/* ===========================
   MAINTENANCE page
   =========================== */
export const maintenancePageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'Maintenance Page',
  description: `The ${CompanyName} website is undergoing updates. I’ll be back with more fire and neon soon.`,
  url: `${FULL_BUSINESS_URL}/maintenance`,
};

export const maintenancePageAdditionalMeta = [
  { property: 'og:title', content: `We'll Be Back Soon - ${CompanyName}` },
  {
    property: 'og:description',
    content: `The site is under maintenance. Return shortly for fresh visuals, tour dates, and booking options.`,
  },
  {
    property: 'og:image',
    content: `${FULL_BUSINESS_URL}/assets/images/pages/maintenance-preview.jpg`,
  },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/maintenance` },
  { name: 'twitter:card', content: 'summary_large_image' },
  { name: 'twitter:title', content: `We'll Be Back Soon - ${CompanyName}` },
  {
    name: 'twitter:description',
    content: `Eyes ever watching. I’ll return with updates soon.`,
  },
  {
    name: 'twitter:image',
    content: `${FULL_BUSINESS_URL}/assets/images/pages/maintenance-preview.jpg`,
  },
];

/* ===========================
   TERMS & POLICIES page
   =========================== */
export const termsAndPoliciesStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'Terms and Policies',
  description: `Review the terms of service and privacy policies of ${CompanyName}.`,
  url: `${FULL_BUSINESS_URL}/terms-and-policies`,
  mainEntity: {
    '@type': 'FAQPage',
    name: 'Terms and Policies FAQ',
    description: `Frequently asked questions about terms of service, privacy, and compliance for ${CompanyName}.`,
  },
};

export const termsAndPoliciesAdditionalMeta = [
  { property: 'og:title', content: `Terms and Policies - ${CompanyName}` },
  {
    property: 'og:description',
    content: `Understand the terms of service and privacy policy for ${CompanyName}.`,
  },
  {
    property: 'og:image',
    content: `${FULL_BUSINESS_URL}/assets/images/pages/terms-preview.jpg`,
  },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/terms-and-policies` },
  { name: 'twitter:card', content: 'summary_large_image' },
  { name: 'twitter:title', content: `Terms and Policies - ${CompanyName}` },
  {
    name: 'twitter:description',
    content: `Legal details and privacy information for ${CompanyName}.`,
  },
  {
    name: 'twitter:image',
    content: `${FULL_BUSINESS_URL}/assets/images/pages/terms-preview.jpg`,
  },
];

/* ===========================
   ERROR (404) page
   =========================== */
export const errorPageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: '404 Error Page',
  description: `The requested page could not be found on ${CompanyName}.`,
  url: `${FULL_BUSINESS_URL}/404`,
  potentialAction: {
    '@type': 'SearchAction',
    target: `${FULL_BUSINESS_URL}/?s={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
};

export const errorPageAdditionalMeta = [
  { property: 'og:title', content: 'Page Not Found - 404' },
  {
    property: 'og:description',
    content: `This page isn’t here. Return to ${CompanyName} and let the neon guide you.`,
  },
  {
    property: 'og:image',
    content: `${FULL_BUSINESS_URL}/assets/images/pages/404-preview.jpg`,
  },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/404` },
  { name: 'twitter:card', content: 'summary_large_image' },
  { name: 'twitter:title', content: 'Page Not Found - 404' },
  {
    name: 'twitter:description',
    content: `Lost? Go back to ${CompanyName} — eyes ever watching.`,
  },
  {
    name: 'twitter:image',
    content: `${FULL_BUSINESS_URL}/assets/images/pages/404-preview.jpg`,
  },
];

/* ===========================
   CONTACT page
   =========================== */
export const contactPageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'ContactPage',
  mainEntity: {
    '@type': 'Organization',
    name: CompanyName,
    url: FULL_BUSINESS_URL,
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: CompanyPhoneNumber,
      contactType: 'Bookings',
      areaServed: 'US',
      availableLanguage: ['English'],
    },
    sameAs: [INSTAGRAM_URL],
    logo: {
      '@type': 'ImageObject',
      url: `${FULL_BUSINESS_URL}/brand/logo.png`,
    },
  },
};

export const contactPageAdditionalMeta = [
  { property: 'og:title', content: `Contact ${CompanyName}` },
  {
    property: 'og:description',
    content: `Book a session with ${CompanyName}. Hypnosis, sensual sadism, indoctrination, and mind play — online or in person.`,
  },
  {
    property: 'og:image',
    content: `${FULL_BUSINESS_URL}/brand/contact-preview.jpg`,
  },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/contact` },
  { name: 'twitter:card', content: 'summary_large_image' },
  { name: 'twitter:title', content: `Contact ${CompanyName}` },
  {
    name: 'twitter:description',
    content: `Inquiries & bookings for Lady Cinder. Enter the neon-gothic dominion.`,
  },
  {
    name: 'twitter:image',
    content: `${FULL_BUSINESS_URL}/brand/contact-preview.jpg`,
  },
];

/* ===========================
   SESSIONS page
   =========================== */
export const sessionsPageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: `${CompanyName} Sessions`,
  url: `${FULL_BUSINESS_URL}/sessions`,
  description: `Book sessions with ${CompanyName}: hypnosis (eyes ever watching), sensual sadism, mind play, indoctrination & propaganda — available online and in person.`,
  isPartOf: {
    '@type': 'WebSite',
    name: CompanyName,
    url: FULL_BUSINESS_URL,
  },
  hasPart: [
    { '@type': 'Service', name: 'Hypnosis', serviceType: 'Hypnosis' },
    {
      '@type': 'Service',
      name: 'Online Sessions',
      serviceType: 'Online Session',
    },
    {
      '@type': 'Service',
      name: 'In-Person Sessions',
      serviceType: 'In-Person Session',
    },
    {
      '@type': 'Service',
      name: 'Sensual Sadism',
      serviceType: 'Sensual Sadism',
    },
    { '@type': 'Service', name: 'Mind Play', serviceType: 'Mind Play' },
    {
      '@type': 'Service',
      name: 'Indoctrination & Propaganda',
      serviceType: 'Indoctrination & Propaganda',
    },
  ],
};

export const sessionsPageAdditionalMeta = [
  { property: 'og:title', content: `${CompanyName} Sessions` },
  {
    property: 'og:description',
    content:
      'Hypnosis, sensual sadism, mind play, and indoctrination. Book online or in person — eyes ever watching.',
  },
  { property: 'og:image', content: `${FULL_BUSINESS_URL}/sessions/cover.jpg` },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/sessions` },
  { name: 'twitter:card', content: 'summary_large_image' },
  { name: 'twitter:title', content: `${CompanyName} Sessions` },
  {
    name: 'twitter:description',
    content:
      'Enter My dominion. Hypnosis, sensual sadism, mind play, indoctrination & propaganda.',
  },
  { name: 'twitter:image', content: `${FULL_BUSINESS_URL}/sessions/cover.jpg` },
];

/* ===========================
   TOUR page
   =========================== */
export const tourPageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: `${CompanyName} Tour`,
  url: `${FULL_BUSINESS_URL}/tour`,
  description: `Touring dominatrix based in LA. View upcoming cities and request bookings with ${CompanyName}.`,
  isPartOf: {
    '@type': 'WebSite',
    name: CompanyName,
    url: FULL_BUSINESS_URL,
  },
};

export const tourPageAdditionalMeta = [
  { property: 'og:title', content: `${CompanyName} Tour` },
  {
    property: 'og:description',
    content:
      'LA-based touring dominatrix. See cities and dates; request your booking.',
  },
  { property: 'og:image', content: `${FULL_BUSINESS_URL}/tour/cover.jpg` },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/tour` },
  { name: 'twitter:card', content: 'summary_large_image' },
  { name: 'twitter:title', content: `${CompanyName} Tour` },
  {
    name: 'twitter:description',
    content: 'On tour. Reserve time with Lady Cinder in your city.',
  },
  { name: 'twitter:image', content: `${FULL_BUSINESS_URL}/tour/cover.jpg` },
];

/* ===========================
   FAQ page
   =========================== */
export const faqPageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  name: `${CompanyName} FAQ`,
  url: `${FULL_BUSINESS_URL}/faq`,
  description: `Frequently asked questions about sessions, bookings, screening, and etiquette for ${CompanyName}.`,
  mainEntity: [
    {
      '@type': 'Question',
      name: 'Do you offer online and in-person sessions?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Yes. I offer hypnosis and select sessions online and in person, subject to screening and availability.',
      },
    },
    {
      '@type': 'Question',
      name: 'How do I request a booking?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Use the contact form to submit your request with preferred dates, city, session type, and screening information.',
      },
    },
    {
      '@type': 'Question',
      name: 'What is your aesthetic and vibe?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Neon-gothic with celestial and sideshow elements — fire, velvet, and divine control.',
      },
    },
    {
      '@type': 'Question',
      name: 'What should I know before a session?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Follow instructions precisely, arrive punctual and clean, and communicate limits clearly. Tribute details are shared after screening.',
      },
    },
  ],
};

export const faqPageAdditionalMeta = [
  { property: 'og:title', content: `${CompanyName} FAQ` },
  {
    property: 'og:description',
    content:
      'Answers about bookings, online vs in-person, etiquette, and what to expect.',
  },
  { property: 'og:image', content: `${FULL_BUSINESS_URL}/faq/cover.jpg` },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/faq` },
  { name: 'twitter:card', content: 'summary_large_image' },
  { name: 'twitter:title', content: `${CompanyName} FAQ` },
  {
    name: 'twitter:description',
    content:
      'Screening, booking, and session details — everything you need before surrender.',
  },
  { name: 'twitter:image', content: `${FULL_BUSINESS_URL}/faq/cover.jpg` },
];

/* ===========================
   LINKS page
   =========================== */
export const linksPageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: `${CompanyName} Links`,
  url: `${FULL_BUSINESS_URL}/links`,
  description: `Find all official links for ${CompanyName}: socials, LoyalFans, gallery, sessions, and tour.`,
  sameAs: [INSTAGRAM_URL],
  isPartOf: {
    '@type': 'WebSite',
    name: CompanyName,
    url: FULL_BUSINESS_URL,
  },
};

export const linksPageAdditionalMeta = [
  { property: 'og:title', content: `${CompanyName} Links` },
  {
    property: 'og:description',
    content:
      'All official places to find Me — socials, booking, tour, gallery.',
  },
  { property: 'og:image', content: `${FULL_BUSINESS_URL}/links/cover.jpg` },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/links` },
  { name: 'twitter:card', content: 'summary_large_image' },
  { name: 'twitter:title', content: `${CompanyName} Links` },
  {
    name: 'twitter:description',
    content: 'One hub for Lady Cinder — follow, watch, and book.',
  },
  { name: 'twitter:image', content: `${FULL_BUSINESS_URL}/links/cover.jpg` },
];

/* ===========================
   DUNGEON page
   =========================== */
export const dungeonPageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: `${CompanyName} Dungeon`,
  url: `${FULL_BUSINESS_URL}/dungeon`,
  description: `A glimpse inside ${CompanyName}'s domain. Black & white film grain with neon magenta tint. Equipment, etiquette, and atmosphere.`,
  isPartOf: {
    '@type': 'WebSite',
    name: CompanyName,
    url: FULL_BUSINESS_URL,
  },
};

export const dungeonPageAdditionalMeta = [
  { property: 'og:title', content: `${CompanyName} Dungeon` },
  {
    property: 'og:description',
    content:
      'Enter the chamber: celestial motifs, iron, and neon glow. Read etiquette and equipment notes.',
  },
  { property: 'og:image', content: `${FULL_BUSINESS_URL}/dungeon/cover.jpg` },
  { property: 'og:url', content: `${FULL_BUSINESS_URL}/dungeon` },
  { name: 'twitter:card', content: 'summary_large_image' },
  { name: 'twitter:title', content: `${CompanyName} Dungeon` },
  {
    name: 'twitter:description',
    content: 'Rules, environment, and expectations before you kneel.',
  },
  { name: 'twitter:image', content: `${FULL_BUSINESS_URL}/dungeon/cover.jpg` },
];
